export default __webpack_public_path__ + "static/media/pall.891d416d.svg";